import { render, staticRenderFns } from "./globalconfig.vue?vue&type=template&id=20b47bdb&scoped=true&"
import script from "./globalconfig.vue?vue&type=script&lang=js&"
export * from "./globalconfig.vue?vue&type=script&lang=js&"
import style0 from "./globalconfig.vue?vue&type=style&index=0&id=20b47bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b47bdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b47bdb')) {
      api.createRecord('20b47bdb', component.options)
    } else {
      api.reload('20b47bdb', component.options)
    }
    module.hot.accept("./globalconfig.vue?vue&type=template&id=20b47bdb&scoped=true&", function () {
      api.rerender('20b47bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/globalconfig.vue"
export default component.exports